import {
  FIELD_REQUIRED,
  INVALID_EMAIL_ADDRESS,
  INVALID_URL,
  INVALID_CREDENTIALS,
  GENERIC_ERROR,
  REQUEST_FAILED,
  PASSWORDS_MISMATCH,
  INVALID_PASSWORD,
  LENGTH_MIN,
  LENGTH_MAX,
  LENGTH_EQUAL,
  INVALID_HEX_COLOR,
  INVALID_GENERIC,
  TOO_MANY_REQUESTS,
  ROLE_IS_REQUIRED,
  PATTERN_MISMATCH,
} from "../../constants/errors";

const errors = {
  [FIELD_REQUIRED]: "This field is required",
  [INVALID_EMAIL_ADDRESS]: "Invalid email address",
  [INVALID_URL]: "Invalid format of URL",
  [INVALID_GENERIC]: "Please enter a valid {{$fieldName}}",
  [PASSWORDS_MISMATCH]: "Passwords do not match.",
  [INVALID_PASSWORD]:
    "Password must be 7 characters and contain at least one digit, one upper case and one lower case letter",
  [INVALID_CREDENTIALS]: "Incorrect email or password.",
  [GENERIC_ERROR]: "Something went wrong, please try again.",
  [REQUEST_FAILED]: "Request failed", // TODO: more granular errors
  [LENGTH_MIN]: "This field must be at least {{$minLength}} characters long",
  [LENGTH_MAX]: "This field must be max {{$maxLength}} characters long",
  [LENGTH_EQUAL]: "This field must be {{$length}} characters long",
  [INVALID_HEX_COLOR]: "Invalid color, please provide a hex color",
  [TOO_MANY_REQUESTS]:
    "Too many failed login attempts, please try again in {{$time}}.",
  [ROLE_IS_REQUIRED]: "Select at least one role",
  [PATTERN_MISMATCH]: "This field accepts only {{$characters}}",
};

export default errors;
